import { Component, OnInit } from '@angular/core';
import { UserService } from '../../shared/user.service';

@Component({
  selector: 'app-intermediate-blocked-sitehouseflats',
  templateUrl: './intermediate-blocked-sitehouseflats.component.html',
  styleUrls: ['./intermediate-blocked-sitehouseflats.component.css']
})
export class IntermediateBlockedSitehouseflatsComponent implements OnInit {
  data: any;
  datalist: any;

  constructor(private userService: UserService) { }

  ngOnInit() {
    this.getInterBlockedSitesHouseFlats();
  }


  getInterBlockedSitesHouseFlats(){

    // document.getElementById('loader').style.display = "block";

    this.data = this.userService.getInterBlockedSitesHouseFlats();
    this.data.subscribe((response:any) => {
        console.log(response);
        this.datalist = response;
        document.getElementById('loader').style.display = "none";
    },(error:any) => {
        console.log(error);
        document.getElementById('loader').style.display = "none";
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/reports/intermediate-blocked-sitehouseflats/intermediate-blocked-sitehouseflats.component.ts